import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import { observer } from 'mobx-react';
import OptimizeImagesService from 'services/OptimizeImages.service';

import messages from './SynergyView.intl';

import styles from './SynergyView.module.scss';

import { Container, Title } from 'common/components/Layout/Layout';
import SynergyItem from './components/SynergyItem/SynergyItem';
import ShortComment from 'common/components/ShortComment/ShortComment';
import DualPhotoSection from 'common/components/DualPhotoSection/DualPhotoSection';

import ContentStore from 'stores/Content.store';
import InjectMetaTags from 'common/components/InjectMetaTags/InjectMetaTags';

import Placeholder from 'common/components/Placeholder/Placeholder';
import BackgroundWithCite from 'common/components/Placeholder/components/BackgroundWithCite/BackgroundWithCite';

@injectIntl
@observer
export default class SynergyView extends Component {
  render() {
    const content = ContentStore.content;
    const commentSize = { width: 90, height: 106 };

    return (
      <div className={styles.SynergyView}>
        {ContentStore.isLoaded && (
          <InjectMetaTags {...ContentStore.content.synergySEO} />
        )}
        <Container>
          <Title title={this.props.intl.formatMessage(messages.heading)} />
        </Container>
        <Placeholder component={<BackgroundWithCite />} ready={!!content}>
          {ContentStore.isLoaded && (
            <div
              className={styles.SectionBG}
              style={{
                backgroundImage: `url(${OptimizeImagesService.adjustImageSize(
                  content.SynergyBackgroundImage
                )})`
              }}
            >
              <Container>
                <div className={styles.CommentContainer}>
                  <ShortComment
                    comment={content.SynergyComment}
                    size={commentSize}
                    className={styles.Comment}
                  />
                </div>
              </Container>
            </div>
          )}
        </Placeholder>
        {ContentStore.isLoaded && (
          <Container>
            <div className={styles.SynergyItemContainer}>
              {content.SynergyShortCompanyDescription.map(item => (
                <SynergyItem key={item.id} specialization={item} />
              ))}
            </div>
            <span className={styles.Line} />
            <p className={styles.Description}>
              {content.SynergyShortGroupDescription}
            </p>
          </Container>
        )}
        {ContentStore.isLoaded && (
          <DualPhotoSection
            image={content.SynergyInfoImage}
            text={content.SynergyInfoText}
            title={content.SynergyInfoTitle}
          />
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/Synergy/SynergyView.js